import { HTTP } from '../../http-common'

export default {
  state: {
    loadedBarnTypes: []
  },
  getters: {
    loadedBarnTypes (state) {
      return state.loadedBarnTypes
    }
  },
  mutations: {
    setLoadedBarnTypes (state, payload) {
      state.loadedBarnTypes = payload
    },
    createBarnType (state, payload) {
      state.loadedBarnTypes.push(payload)
    },
    updateBarnType (state, payload) {
      state.loadedBarnTypes = state.loadedBarnTypes.map(barnType => barnType.id === payload.id ? payload : barnType)
    },
    removeBarnType (state, id) {
      state.loadedBarnTypes = state.loadedBarnTypes.filter(barnType => {
        return barnType.id !== id
      })
    },
    clearLoadedBarnTypes (state) {
      state.loadedBarnTypes = []
    }
  },
  actions: {
    loadBarnTypes ({ commit }) {
      commit('clearError')
      commit('setLoading', true)
      commit('setLoadedBarnTypes', [])

      return new Promise((resolve, reject) => {
        HTTP.get('barn_type.json')
          .then(result => {
            console.log(result.data)
            commit('setLoadedBarnTypes', result.data.results)
            resolve(result.data)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    createBarnType ({ commit, getters }, payload) {
      console.log('createBarnType')
      commit('clearError')
      commit('setLoading', true)
      const newBarnType = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.post('barn_type.json/', newBarnType)
          .then(result => {
            console.log(result)
            commit('createBarnType', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    updateBarnType ({ commit, getters }, payload) {
      console.log('updateBarnType')
      commit('clearError')
      commit('setLoading', true)
      const barnType = {
        description: payload.description
      }
      return new Promise((resolve, reject) => {
        HTTP.patch(`barn_type.json/${payload.id}/`, barnType)
          .then(result => {
            console.log(result)
            commit('updateBarnType', result.data)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    removeBarnType ({ commit }, payload) {
      console.log('removeBarnType')
      commit('clearError')
      commit('setLoading', true)
      return new Promise((resolve, reject) => {
        HTTP.delete(`barn_type.json/${payload}`)
          .then(result => {
            console.log('result', result)
            commit('removeBarnType', payload)
            resolve(result)
          })
          .catch(err => {
            console.log(err)
            commit('setError', err)
            reject(err)
          })
          .finally(() => {
            commit('setLoading', false)
          })
      })
    },
    clearLoadedBarnTypes ({ commit }) {
      commit('clearLoadedBarnTypes')
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/barn_type/index.js